export default __webpack_public_path__ + "static/media/Background_00214.74c1f91c.png";